import createModel, { Mapped, Union } from "@/__main__/data-model.mjs";

const apiModelValidation = createModel({
  ...Mapped({
    key: String,
    value: Mapped({
      key: String,
      value: {
        requirement: Number,
        value: Number,
        split: [
          {
            loot: [
              Mapped({
                key: String,
                value: Union([Number, String, [String]]),
              }),
            ],
            odds: Number,
          },
        ],
      },
    }),
  }),
});

function transform(data) {
  return apiModelValidation(data);
}

export default transform;

export type TftLootTables = ReturnType<typeof transform>;
